import React, { FC } from 'react';
import getPreselectedValuesFromParams from 'app/components/timeSavers/assignMultipleTasksModal/utils/getPreselectedValuesFromParams';
import SendForApprovalPreselectedPosts from './sendForApproval/SendForApprovalPreselectedPosts';
import SendForApprovalWithPostsSelection from './sendForApproval/SendForApprovalWithPostsSelection';
import { ModalRouteProps } from 'context/ModalRouter';
import { useQueryClient } from 'react-query';
import { queryKey } from 'constants/queryKey';
import { useToast } from 'app/hooks/useToast';
import { useG2ReviewTrigger } from 'app/hooks/useG2ReviewTrigger';
import { usePostsContainer } from 'components/posts/context';
import { useTranslation } from 'react-i18next';

type Props = ModalRouteProps;

const SendForClientApproval: FC<Props> = (props) => {
  const queryClient = useQueryClient();
  const postsContainer = usePostsContainer();
  const toast = useToast();
  const { t } = useTranslation();
  const { triggerG2Review } = useG2ReviewTrigger();

  const hasPreselectedPosts = (): boolean => {
    const preselectedValues = getPreselectedValuesFromParams(
      props.modalManager,
    );

    return preselectedValues.posts.length !== 0;
  };

  const handleSuccessRequestTasks = ({
    hasPartialFailure,
  }: {
    hasPartialFailure: boolean;
  }) => {
    queryClient.invalidateQueries(queryKey.posts());
    postsContainer.clearSelectedPosts();

    if (!hasPartialFailure) {
      toast(t('postsSentForApproval'), 'success');
    }

    props.modalManager.close();
    triggerG2Review();
  };

  if (hasPreselectedPosts()) {
    return (
      <SendForApprovalPreselectedPosts
        type="client"
        onSuccessFormResponse={handleSuccessRequestTasks}
        modalManager={props.modalManager}
      />
    );
  }

  return (
    <SendForApprovalWithPostsSelection
      type="client"
      onSuccessFormResponse={handleSuccessRequestTasks}
      modalManager={props.modalManager}
    />
  );
};

export default SendForClientApproval;
